<template>
  <v-card>
    <v-card-title primary-title>
      <v-layout row wrap>
        <v-flex xs6>
          <h3 class="headline mb-0 ml-3" v-if="race">{{ race.name }}</h3>
        </v-flex>
        <v-flex xs6>
          <VSelect
            hide-details
            :items="categories"
            solo
            :label="this.$t('application.category')"
            @change="categoryChange"
            v-model="filterCategory"
            v-if="showFilter"
          ></VSelect>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text class="v-card__text">
      <v-data-table
        :headers="headers"
        :items="this.runs"
        single-expand
        :expanded.sync="expanded"
        show-expand
        must-sort
        :sort-by.sync="sorting"
        dense
        hide-default-headers
        hide-default-footer
        disable-pagination
        :loading="loading"
      >
        <template v-slot:item="{item, isExpanded, expand}">
          <tr
            @click="expand(!isExpanded)"
            :class="(item.disqualification?'grey':
											(item.startNumber % 2 == 0 ? 'red':'blue'))
											+' '+colorModifier+' '
                      +((item.startNumber % 2 == 0 && sorting == 'startNumber') 
                        ? (isExpanded ? 'borderNone' : 'borderBottom')
                        : 'borderTop')"
                      >
            <td>
              <v-icon v-if="!isExpanded">keyboard_arrow_down</v-icon>
              <v-icon v-else>keyboard_arrow_up</v-icon>
            </td>
            <td v-if="!isTournament">
              <span v-if="!item.disqualification && item.totalTime">{{item.place}}</span>
            </td>
            <td>{{item.startNumber}}</td>
            <td>
              <v-tooltip
                bottom v-if="!item.application.allowedToStart && !item.disqualification">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="red">cancel</v-icon>
                </template>
                <span>{{$t("results.notReadyToStart")}}</span>
              </v-tooltip>
              <span v-if="$store.getters['isAdministrator']">
                <router-link
                  :to="'/app/applications/'+item.application.id"
                  >{{dots(item.application.title, 30)}}</router-link>
              </span>
              <span v-else-if="item.application.title.length < 30">
                {{item.application.title}}
              </span>
              <v-tooltip bottom v-else>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{dots(item.application.title, 30)}}</span>
                </template>
                <span>{{item.application.title}}</span>
              </v-tooltip>
            </td>
            <td v-if="!isTournament">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{item.application.assignedCategory.label}}</span>
                </template>
                <span>{{item.application.assignedCategory.name}}</span>
              </v-tooltip>
            </td>
            <td v-if="item.application.applicationType == 0">
              <span v-if="item.application.applicationCompetitors[0].competitor.department.length < 20"
              >{{ item.application.applicationCompetitors[0].competitor.department }}</span>
              <v-tooltip bottom v-else>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ dots(item.application.applicationCompetitors[0].competitor.department, 20) }}</span>
                </template>
                <span>{{ item.application.applicationCompetitors[0].competitor.department }}</span>
              </v-tooltip>
            </td>
            <td>
              <div v-if="item.disqualification">DSQ</div>
              <v-tooltip bottom v-else-if="item.totalTime != null">
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{item.totalTime | runTime}}
                    <v-icon color="yellow" v-if="isTournament && isWinner(item)">mdi-star</v-icon>
                  </span>
                </template>
                <span>{{item.time | runTime}} + {{ item.additionalTime | seconds }} s</span>
              </v-tooltip>
              <v-tooltip bottom v-else-if="item.preliminaryTime != null">
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{item.preliminaryTime | runTime}}
                    <v-icon color="yellow">mdi-alert</v-icon>
                  </span>
                </template>
                <span>{{ $t("application.unofficial") }}</span>
              </v-tooltip>
              <v-icon v-else-if="item.start != null && item.end == null" class="blinking">mdi-timer</v-icon>
            </td>
          </tr>
        </template>
        <template v-slot:expanded-item="{ item }">
          <tr
            :class="(item.disqualification?'grey':(item.startNumber % 2 == 0 ? 'red':'blue'))+' '+colorModifier"
          >
            <td colspan="7">
              <v-chip v-for="c in item.application.applicationCompetitors" :key="c.id">
                <flag :iso="c.competitor.country" />
                &nbsp; {{c.competitor.firstName}} {{c.competitor.lastName}}
              </v-chip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  VDataTable,
  VCard,
  VCardText,
  VCardTitle,
  VSelect,
  VTooltip,
  VChip,
  VIcon
} from "vuetify/lib";
import fccapi from "../fccapi.js";

export default {
  name: "ResultsCard",
  data: () => ({
    runs: [],
    allRuns: [],
    loading: false,
    categories: [],
    filterCategory: "/",
    showFilter: true,
    sorting: "startNumber",
    expanded: []
  }),
  props: {
    race: Object
  },
  methods: {
    categoryChange: function() {
      this.runs = this.allRuns.filter(
        a =>
          this.filterCategory == "/" ||
          a.application.assignedCategory.name == this.filterCategory
      );
      this.runs.sort((a, b) => {
        if (a.disqualification || !a.totalTime) return 1;
        if (b.disqualification || !b.totalTime) return -1;
        return a.totalTime > b.totalTime ? 1 : -1;
      });
      this.runs = this.runs.map((v, i) => {
        if (!v.disqualification && v.totalTime) v.place = i + 1;
        return v;
      });
    },
    expand: function(item) {
      this.expanded.push(item);
    },
    dots: function(str, length) {
      if (str.length >= length) return str.substring(0, length - 3) + "...";
      else return str;
    },
    reload: function(){
      this.allRuns = [];
      this.runs = [];
      if(!this.race) return;
      this.loading = true;
      fccapi.get(`races/${this.race.id}/runs`).then(d => {
        this.allRuns = d.data;
        this.initializeDisplay();
      });
    },
    onRunUpdated: function({run}){
      console.log("Run updated")
      console.log(run)
      this.loading = true;
      for(var i = 0; i < this.runs.length; i++){
        if(this.runs[i].id == run.id){
          console.log("Found " + run.id + " at index " + i + " time is " + run.time)
          this.runs[i].time = run.time
          this.runs[i].preliminaryTime = run.preliminaryTime;
          this.runs[i].end = run.end;
          this.runs[i].start = run.start;
          this.runs[i].totalTime = run.totalTime;
          this.runs[i].additionalTime = run.additionalTime;
          this.runs[i].disqualification = run.disqualification;
          this.runs[i].remarks = run.remarks;
          this.runs[i].runPenalities = run.runPenalities;
          break;
        }
      }
      this.initializeDisplay();
    },
    initializeDisplay: function(){
      this.runs = this.allRuns;
      this.runs.sort((a, b) => {
        if (a.disqualification || !a.totalTime) return 1;
        if (b.disqualification || !b.totalTime) return -1;
        return a.totalTime > b.totalTime ? 1 : -1;
      });
      this.runs = this.runs.map((v, i) => {
        if (!v.disqualification && v.totalTime) v.place = i + 1;
        else v.place = "999999";
        return v;
      });
      this.loading = false;
      this.categories = this.runs.map(v => v.application.assignedCategory.name);
      this.categories = this.categories.filter((v, i, a) => a.indexOf(v) === i);
      if (this.categories.length == 1) this.showFilter = false;
      this.categories.unshift("/");
    },
    isWinner: function(run)
    {
      if (run.disqualification || !run.totalTime) return false;

      var startIndex = Math.floor((run.startNumber - 1) / 2);
      var otherStartNumber = startIndex * 2;
      if (run.startNumber % 2 == 1) {
        otherStartNumber++;
      }
      
      var other = this.allRuns.find((r) => r.startNumber - 1 == otherStartNumber);
      if (!other.totalTime) return false;
      if (other.disqualification) return true;
      return run.totalTime < other.totalTime;
    }
  },
  computed: {
    genders: function() {
      return [this.$t("profile.male"), this.$t("profile.female")];
    },
    selectedCompetition: function() {
      return this.$store.getters["competitionId"];
    },
    headers: function() {
      var h = [
        { text: /*this.$t("runs.startNumber")*/ "#", value: "startNumber" },
        { text: this.$t("application.title"), value: "application.title" }
      ];
      if (!this.isTournament)
      {
        h.unshift({ text: this.$t("runs.place"), value: "place" });
        h.push({
          text: this.$t("application.category"),
          value: "application.assignedCategory"
        });
      }
      if (this.allRuns[0] && this.allRuns[0].application.applicationType == 0)
        h.push({
          text: this.$t("competitor.department"),
          value: "application.applicationCompetitors[0].competitor.department"
        });
      h.push({ text: this.$t("runs.totalTime"), value: "totalTime" });
      return h;
    },
    selectedRace: function(){
      return this.race;
    },
    colorModifier: function(){
      return this.$vuetify.theme.dark?"darken-4":"lighten-4";
    },
    isTournament: function()
    {
      return this.race != null && this.race.previousRaceId != null;
    }
  },
  components: {
    VDataTable,
    VCard,
    VCardText,
    VCardTitle,
    VSelect,
    VTooltip,
    VChip,
    VIcon
  },
  created() {
    this.$resultsHub.$on('run-updated', this.onRunUpdated)
  },
  mounted() {
    this.reload();
  },
  watch: {
    selectedRace: function(){
      this.reload();
    }
  },
  filters: {
    runTime: function(t) {
      var r = new RegExp("\\d{2}:(\\d{2}:(\\d{2}(\\.\\d{2})?))", "g");
      var result = r.exec(t);
      if (!result) return "";
      return result[1].trimLeft();
    },
    seconds: function(t) {
      var r = new RegExp("\\d{2}:(\\d{2}):(\\d{2}(\\.\\d{2})?)", "g");
      var result = r.exec(t);
      if (!result) return "";
      return parseInt(result[1]) * 60 + parseFloat(result[2]);
    }
  }
};
</script>
<style>
th {
  padding: 2px !important;
}
.borderNone>td{
  border-bottom: 0px solid #777 !important;
  border-top: 0px solid #777 !important;
}
.borderBottom>td{
  border-bottom: 1px solid #555 !important;
}
.borderTop>td{
  border-top: 1px solid #555 !important;
}
.blinking {
  -webkit-animation: BLINK-ANIMATION 1s infinite;  /* Safari 4+ */
  -moz-animation: BLINK-ANIMATION 1s infinite;  /* Fx 5+ */
  -o-animation: BLINK-ANIMATION 1s infinite;  /* Opera 12+ */
  animation: BLINK-ANIMATION 1s infinite;  /* IE 10+, Fx 29+ */
}

@-webkit-keyframes BLINK-ANIMATION {
  0%, 49% {
    visibility: hidden;
  }
  50%, 100% {
    visibility: visible;
  }
}
</style>
<style scoped>
.v-text-field__details {
  display: none;
}
tr.darken-4 a{
  color: white;
}
tr.lighten-4 a {
  color: black;
}
</style>